<footer class="footer-container">

  <div class="footer-divider"></div>

  <div class="footer-content">

    <div class="footer-brand">
      <h2 class="brand-name">MOANANI</h2>
      <p class="brand-quote">"I GOT LOVE "</p>
      <div class="tech-data">
        <span>2026  </span>
        <span>•</span>
        <span>  LIMA,PE</span>
      </div>
    </div>

    <div class="footer-links">
      <h3 class="section-title">EXPLORAR</h3>
      <ul>
        <li><a routerLink="/shop">Tienda</a></li>
        <li><a routerLink="/club">Club</a></li>
        <li><a routerLink="/shop">Catálogo</a></li>
      </ul>
    </div>

    <div class="footer-links">
      <h3 class="section-title">LEGAL</h3>
      <ul>
        <li><a routerLink="/club">Términos</a></li>
        <li><a routerLink="/club">Envíos</a></li>
        <li><a routerLink="/club">Devoluciones</a></li>
      </ul>
    </div>

    <div class="footer-newsletter">
      <h3 class="section-title">Únete al Club</h3>
      <app-club-subscribe source="footer" variant="footer"></app-club-subscribe>
    </div>

  </div>

  <div class="footer-bottom">
    <span>© 2026 MOANANI. TODOS LOS DERECHOS RESERVADOS</span>
    <span class="system-code">VER.1.0</span>
  </div>

</footer>